<button
  type="button"
  attr.aria-label="{{ 'addToCart.addToCartModal.editBtnLabel' | transloco }}"
>
  <span>{{ value() }}</span>
  <fa-icon [icon]="faPencil"></fa-icon>
</button>
